import { useState } from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { getErrorsForField } from '@utils/serializable_error.ts'
import { selectors as entitySelectors, actions as entityActions } from '@features/entity_saver/index.js'
import Status from '@constants/request_statuses.ts'
import ErrorWrapper from './ErrorWrapper.tsx'
import Switch from './Switch.tsx'

const { saveEntity } = entityActions
const { selectEntityRequestStatus, selectEntityRequestError } = entitySelectors

const PublishSwitch = props => {
  const {
    entity,
    resourceType,
    resourceId,

    publishStatusAttribute = 'publish_status_code',
    publishedValue = 1,
    unpublishedValue = 0,
    publishedLabel = 'Published',
    unpublishedLabel = 'Draft',
  } = props
  const initialPublishStatus = entity[publishStatusAttribute] || unpublishedValue

  const dispatch = useDispatch()
  const [publishStatus, setPublishStatus] = useState(initialPublishStatus)

  const lowerCaseResourceType = resourceType.toLowerCase()

  const handlePublishSwitchChange = value => {
    setPublishStatus(value) // optimistically updates local state before dispatching
    dispatch(
      saveEntity({
        id: resourceId,
        attributes: {
          id: resourceId,
          [publishStatusAttribute]: value,
        },
        type: lowerCaseResourceType,
      })
    )
  }

  const status =
    useSelector(state => selectEntityRequestStatus(state, { id: resourceId, type: lowerCaseResourceType })) ||
    Status.IDLE
  const error =
    useSelector(state => selectEntityRequestError(state, { id: resourceId, type: lowerCaseResourceType })) || {}

  let errorsArray = getErrorsForField(error, publishStatusAttribute)
  return (
    <ErrorWrapper errors={errorsArray}>
      <Switch
        checkedLabel={publishedLabel}
        uncheckedLabel={unpublishedLabel}
        checkedValue={publishedValue}
        uncheckedValue={unpublishedValue}
        value={publishStatus}
        onChange={handlePublishSwitchChange}
        className="labelled-switch labelled-switch--small"
      />
      <div className="clearfix"></div>
    </ErrorWrapper>
  )
}

PublishSwitch.propTypes = {
  resourceId: PropTypes.number.isRequired,
  resourceType: PropTypes.string.isRequired,
  entity: PropTypes.object.isRequired,
}

export default PublishSwitch
